// src/pages/LoginPage.jsx
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Text, Input, Button, VStack, IconButton, InputGroup, InputRightElement } from "@chakra-ui/react";
import { LuEye, LuEyeOff } from "react-icons/lu";
import AuthContext from "../context/AuthContext";
import AuthPage from "../components/AuthPage";

export default function LoginPage() {
  const { user, login, loadingAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [showPw, setShowPw] = useState(false);

  useEffect(() => {
    if (!loadingAuth && user && window.location.pathname === "/login") {
      navigate("/dashboard", { replace: true });
    }
  }, [user, loadingAuth, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email.trim()) newErrors.email = "E-Mail ist erforderlich.";
    if (!formData.password.trim()) newErrors.password = "Passwort ist erforderlich.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    await login(formData.email, formData.password);
  };

  const inputProps = {
    bg: "blue.300",
    color: "white",
    _placeholder: { color: "whiteAlpha.800" },
    borderColor: "whiteAlpha.700",
    _hover: { borderColor: "whiteAlpha.900" },
    _focus: { bg: "blue.300", borderColor: "white", color: "white" },
    _light: { color: "black", _placeholder: { color: "blackAlpha.500" } },
  };

  return (
    <AuthPage title="🔐 Login" subtitle="Willkommen zurück! Bitte melde dich an.">
      <form onSubmit={handleSubmit}>
        <VStack gap={4} align="stretch">
          <Box>
            <Text fontWeight="semibold" mb={1}>E-Mail</Text>
            <Input {...inputProps} id="email" name="email" type="email" placeholder="dein@email.de"
              value={formData.email} onChange={handleChange} autoComplete="email" />
            {errors.email && <Text color="red.500" fontSize="sm">{errors.email}</Text>}
          </Box>

          <Box>
            <Text fontWeight="semibold" mb={1}>Passwort</Text>
            <Box position="relative">
              <Input
                id="password"
                name="password"
                type={showPw ? "text" : "password"}
                placeholder="••••••••"
                value={formData.password}
                onChange={handleChange}
                autoComplete="current-password"
                pr="2.5rem"  // adds padding to avoid overlap
                {...inputProps}
              />
              <IconButton
                aria-label={showPw ? "Passwort verbergen" : "Passwort anzeigen"}
                size="sm"
                variant="ghost"
                icon={showPw ? <LuEyeOff /> : <LuEye />}
                onClick={() => setShowPw((s) => !s)}
                position="absolute"
                right="0.5rem"
                top="50%"
                transform="translateY(-50%)"
              />
            </Box>
            {errors.password && <Text color="red.500" fontSize="sm">{errors.password}</Text>}
          </Box>

          <Button type="submit" colorScheme="blue" size="lg" isLoading={loadingAuth}>
            Login
          </Button>
        </VStack>
      </form>
    </AuthPage>
  );
}